






























import {
  ref,
  useRoute,
  useRouter,
  watch,
  computed,
} from '@nuxtjs/composition-api';
import { TabControls, BaseButton } from '@bambeehr/pollen';
import BreadCrumbs from '@/components/BreadCrumbs';
import ContentBanner from '@/components/ContentBanner/ContentBanner';

export enum TabPages {
  COMPANY = 'company',
  MY_COURSES = 'my-courses',
  OVERVIEW = 'overview',
  REQUESTS = 'requests',
}

interface TabOption {
  label: string;
  value: TabPages;
}

export const tabOptions = [
  {
    label: 'Overview',
    value: TabPages.OVERVIEW,
  },
  {
    label: 'Company Courses',
    value: TabPages.COMPANY,
  },
  {
    label: 'My Courses',
    value: TabPages.MY_COURSES,
  },
  {
    label: 'Requests',
    value: TabPages.REQUESTS,
  },
];

export const getCurrentTab = (route): TabOption =>
  tabOptions.find((tab) => route.path.includes(tab.value)) as TabOption;

export default {
  components: {
    TabControls,
    BaseButton,
    BreadCrumbs,
    ContentBanner,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const currentPage = ref<TabOption>();
    const isRoot = computed(() => route.value.path === '/training');
    const isOverview = computed(
      () => currentPage.value?.value === TabPages.OVERVIEW
    );

    watch(
      isRoot,
      (shouldRedirect) => {
        if (shouldRedirect) {
          router.push({ path: `/training/${TabPages.COMPANY}` });
        }
      },
      { immediate: true }
    );

    watch(
      route,
      (newRoute) => {
        currentPage.value = getCurrentTab(newRoute);
      },
      { immediate: true }
    );

    const handleTabUpdate = (newPage) => {
      router.push({ path: `/training/${newPage}` });
    };

    const crumbs = computed(() => [
      {
        label: 'Training',
        to: '/training/overview',
      },
      {
        label: currentPage.value?.label,
      },
    ]);

    return {
      currentPage,
      tabOptions,
      handleTabUpdate,
      crumbs,
      isOverview,
    };
  },
};
